import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import TaskAdd from "./TaskAdd";
import TaskDetail from "./TaskDetail";
import TasksList from "./TasksList";
export default class Tasks extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      mode: null,
      taskId: null,
    };
  }

  componentDidMount() {
    this.initRouteState();
    this.renderButtons();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.urlParam1 !== this.props.urlParam1) {
      this.initRouteState();
    }
    this.renderButtons();
  }

  renderButtons = () => {
    if (this.state.mode === "add") {
      this.context.actionsSet(<></>);
    } else {
      this.context.actionsSet(
        <>
          <a
            href="/tasks/add/"
            className="btn btn-icon text-muted bg-light mr-2"
          >
            <span className="flaticon2-add-1 px-2 align-middle"></span>
          </a>
        </>
      );
    }
  };

  initRouteState = () => {
    const param = this.props.urlParam1;
    this.setState({ taskId: null, mode: param });
  };

  renderNav() {
    let nav = {
      current: "Текущие",
      expired: "Пропущенные",
      future: "Будущие",
      completed: "Завершенные",
      postponed: "Отложенные",
    };
    const notifierValues = this.context.notifier.task || {};
    let pills = {
      expired: notifierValues.expired ? (
        <span className="label label-danger ml-2">
          {notifierValues.expired}
        </span>
      ) : null,
      current: notifierValues.enabled ? (
        <span className="label label-primary ml-2">
          {notifierValues.enabled}
        </span>
      ) : null,
      future: notifierValues.planned ? (
        <span className="label label-secondary ml-2">
          {notifierValues.planned}
        </span>
      ) : null,
    };
    return (
      <ul className="nav nav-tabs">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/tasks/${id}/`}
              className={` ${
                this.state.mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
              {pills[id]}
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.mode === "add") {
      return (
        <>
          <CrumbsProvider title="Планировщик задач" />
          <div className="container">
            <TaskAdd />
          </div>
        </>
      );
    }
    if (this.state.mode === "detail") {
      return (
        <>
          <CrumbsProvider title="Планировщик задач" />
          <div className="container">
            <TaskDetail key={this.state.taskId} id={this.state.taskId} />
          </div>
        </>
      );
    }
    return (
      <>
        <CrumbsProvider title="Планировщик задач" />
        <div className="container">
          {this.renderNav()}
          <TasksList mode={this.state.mode} />
        </div>
        <br />
      </>
    );
  }
}
